function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@asgerb/apparatus-shop"] = t() : e["@asgerb/apparatus-shop"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 10);
  }([function (e, t, n) {
    "use strict";

    var r = function () {
      function e(e, t) {
        this.eventTarget = e, this.eventName = t, this.unorderedBindings = new Set();
      }

      return e.prototype.connect = function () {
        this.eventTarget.addEventListener(this.eventName, this, !1);
      }, e.prototype.disconnect = function () {
        this.eventTarget.removeEventListener(this.eventName, this, !1);
      }, e.prototype.bindingConnected = function (e) {
        this.unorderedBindings.add(e);
      }, e.prototype.bindingDisconnected = function (e) {
        this.unorderedBindings.delete(e);
      }, e.prototype.handleEvent = function (e) {
        for (var t = function (e) {
          if (("immediatePropagationStopped" in e)) return e;
          var t = e.stopImmediatePropagation;
          return Object.assign(e, {
            immediatePropagationStopped: !1,
            stopImmediatePropagation: function stopImmediatePropagation() {
              this.immediatePropagationStopped = !0, t.call(this);
            }
          });
        }(e), n = 0, r = this.bindings; n < r.length; n++) {
          var o = r[n];
          if (t.immediatePropagationStopped) break;
          o.handleEvent(t);
        }
      }, Object.defineProperty(e.prototype, "bindings", {
        get: function get() {
          return Array.from(this.unorderedBindings).sort(function (e, t) {
            var n = e.index,
                r = t.index;
            return n < r ? -1 : n > r ? 1 : 0;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    var o = function () {
      function e(e) {
        this.application = e, this.eventListenerMaps = new Map(), this.started = !1;
      }

      return e.prototype.start = function () {
        this.started || (this.started = !0, this.eventListeners.forEach(function (e) {
          return e.connect();
        }));
      }, e.prototype.stop = function () {
        this.started && (this.started = !1, this.eventListeners.forEach(function (e) {
          return e.disconnect();
        }));
      }, Object.defineProperty(e.prototype, "eventListeners", {
        get: function get() {
          return Array.from(this.eventListenerMaps.values()).reduce(function (e, t) {
            return e.concat(Array.from(t.values()));
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.bindingConnected = function (e) {
        this.fetchEventListenerForBinding(e).bindingConnected(e);
      }, e.prototype.bindingDisconnected = function (e) {
        this.fetchEventListenerForBinding(e).bindingDisconnected(e);
      }, e.prototype.handleError = function (e, t, n) {
        void 0 === n && (n = {}), this.application.handleError(e, "Error " + t, n);
      }, e.prototype.fetchEventListenerForBinding = function (e) {
        var t = e.eventTarget,
            n = e.eventName;
        return this.fetchEventListener(t, n);
      }, e.prototype.fetchEventListener = function (e, t) {
        var n = this.fetchEventListenerMapForEventTarget(e),
            r = n.get(t);
        return r || (r = this.createEventListener(e, t), n.set(t, r)), r;
      }, e.prototype.createEventListener = function (e, t) {
        var n = new r(e, t);
        return this.started && n.connect(), n;
      }, e.prototype.fetchEventListenerMapForEventTarget = function (e) {
        var t = this.eventListenerMaps.get(e);
        return t || (t = new Map(), this.eventListenerMaps.set(e, t)), t;
      }, e;
    }(),
        i = /^((.+?)(@(window|document))?->)?(.+?)(#(.+))?$/;

    var s = function () {
      function e(e, t, n) {
        this.element = e, this.index = t, this.eventTarget = n.eventTarget || e, this.eventName = n.eventName || function (e) {
          var t = e.tagName.toLowerCase();
          if (t in a) return a[t](e);
        }(e) || c("missing event name"), this.identifier = n.identifier || c("missing identifier"), this.methodName = n.methodName || c("missing method name");
      }

      return e.forToken = function (e) {
        return new this(e.element, e.index, (n = e.content, r = n.trim().match(i) || [], {
          eventTarget: (t = r[4], "window" == t ? window : "document" == t ? document : void 0),
          eventName: r[2],
          identifier: r[5],
          methodName: r[7]
        }));
        var t, n, r;
      }, e.prototype.toString = function () {
        var e = this.eventTargetName ? "@" + this.eventTargetName : "";
        return "" + this.eventName + e + "->" + this.identifier + "#" + this.methodName;
      }, Object.defineProperty(e.prototype, "eventTargetName", {
        get: function get() {
          return (e = this.eventTarget) == window ? "window" : e == document ? "document" : void 0;
          var e;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        a = {
      a: function a(e) {
        return "click";
      },
      button: function button(e) {
        return "click";
      },
      form: function form(e) {
        return "submit";
      },
      input: function input(e) {
        return "submit" == e.getAttribute("type") ? "click" : "change";
      },
      select: function select(e) {
        return "change";
      },
      textarea: function textarea(e) {
        return "change";
      }
    };

    function c(e) {
      throw new Error(e);
    }

    var u = function () {
      function e(e, t) {
        this.context = e, this.action = t;
      }

      return Object.defineProperty(e.prototype, "index", {
        get: function get() {
          return this.action.index;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "eventTarget", {
        get: function get() {
          return this.action.eventTarget;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.context.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.handleEvent = function (e) {
        this.willBeInvokedByEvent(e) && this.invokeWithEvent(e);
      }, Object.defineProperty(e.prototype, "eventName", {
        get: function get() {
          return this.action.eventName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "method", {
        get: function get() {
          var e = this.controller[this.methodName];
          if ("function" == typeof e) return e;
          throw new Error('Action "' + this.action + '" references undefined method "' + this.methodName + '"');
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.invokeWithEvent = function (e) {
        try {
          this.method.call(this.controller, e);
        } catch (n) {
          var t = {
            identifier: this.identifier,
            controller: this.controller,
            element: this.element,
            index: this.index,
            event: e
          };
          this.context.handleError(n, 'invoking action "' + this.action + '"', t);
        }
      }, e.prototype.willBeInvokedByEvent = function (e) {
        var t = e.target;
        return this.element === t || !(t instanceof Element && this.element.contains(t)) || this.scope.containsElement(t);
      }, Object.defineProperty(e.prototype, "controller", {
        get: function get() {
          return this.context.controller;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "methodName", {
        get: function get() {
          return this.action.methodName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "scope", {
        get: function get() {
          return this.context.scope;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        l = function () {
      function e(e, t) {
        var n = this;
        this.element = e, this.started = !1, this.delegate = t, this.elements = new Set(), this.mutationObserver = new MutationObserver(function (e) {
          return n.processMutations(e);
        });
      }

      return e.prototype.start = function () {
        this.started || (this.started = !0, this.mutationObserver.observe(this.element, {
          attributes: !0,
          childList: !0,
          subtree: !0
        }), this.refresh());
      }, e.prototype.stop = function () {
        this.started && (this.mutationObserver.takeRecords(), this.mutationObserver.disconnect(), this.started = !1);
      }, e.prototype.refresh = function () {
        if (this.started) {
          for (var e = new Set(this.matchElementsInTree()), t = 0, n = Array.from(this.elements); t < n.length; t++) {
            var r = n[t];
            e.has(r) || this.removeElement(r);
          }

          for (var o = 0, i = Array.from(e); o < i.length; o++) {
            r = i[o];
            this.addElement(r);
          }
        }
      }, e.prototype.processMutations = function (e) {
        if (this.started) for (var t = 0, n = e; t < n.length; t++) {
          var r = n[t];
          this.processMutation(r);
        }
      }, e.prototype.processMutation = function (e) {
        "attributes" == e.type ? this.processAttributeChange(e.target, e.attributeName) : "childList" == e.type && (this.processRemovedNodes(e.removedNodes), this.processAddedNodes(e.addedNodes));
      }, e.prototype.processAttributeChange = function (e, t) {
        var n = e;
        this.elements.has(n) ? this.delegate.elementAttributeChanged && this.matchElement(n) ? this.delegate.elementAttributeChanged(n, t) : this.removeElement(n) : this.matchElement(n) && this.addElement(n);
      }, e.prototype.processRemovedNodes = function (e) {
        for (var t = 0, n = Array.from(e); t < n.length; t++) {
          var r = n[t],
              o = this.elementFromNode(r);
          o && this.processTree(o, this.removeElement);
        }
      }, e.prototype.processAddedNodes = function (e) {
        for (var t = 0, n = Array.from(e); t < n.length; t++) {
          var r = n[t],
              o = this.elementFromNode(r);
          o && this.elementIsActive(o) && this.processTree(o, this.addElement);
        }
      }, e.prototype.matchElement = function (e) {
        return this.delegate.matchElement(e);
      }, e.prototype.matchElementsInTree = function (e) {
        return void 0 === e && (e = this.element), this.delegate.matchElementsInTree(e);
      }, e.prototype.processTree = function (e, t) {
        for (var n = 0, r = this.matchElementsInTree(e); n < r.length; n++) {
          var o = r[n];
          t.call(this, o);
        }
      }, e.prototype.elementFromNode = function (e) {
        if (e.nodeType == Node.ELEMENT_NODE) return e;
      }, e.prototype.elementIsActive = function (e) {
        return e.isConnected == this.element.isConnected && this.element.contains(e);
      }, e.prototype.addElement = function (e) {
        this.elements.has(e) || this.elementIsActive(e) && (this.elements.add(e), this.delegate.elementMatched && this.delegate.elementMatched(e));
      }, e.prototype.removeElement = function (e) {
        this.elements.has(e) && (this.elements.delete(e), this.delegate.elementUnmatched && this.delegate.elementUnmatched(e));
      }, e;
    }(),
        f = function () {
      function e(e, t, n) {
        this.attributeName = t, this.delegate = n, this.elementObserver = new l(e, this);
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.elementObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "selector", {
        get: function get() {
          return "[" + this.attributeName + "]";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.elementObserver.start();
      }, e.prototype.stop = function () {
        this.elementObserver.stop();
      }, e.prototype.refresh = function () {
        this.elementObserver.refresh();
      }, Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.elementObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.matchElement = function (e) {
        return e.hasAttribute(this.attributeName);
      }, e.prototype.matchElementsInTree = function (e) {
        var t = this.matchElement(e) ? [e] : [],
            n = Array.from(e.querySelectorAll(this.selector));
        return t.concat(n);
      }, e.prototype.elementMatched = function (e) {
        this.delegate.elementMatchedAttribute && this.delegate.elementMatchedAttribute(e, this.attributeName);
      }, e.prototype.elementUnmatched = function (e) {
        this.delegate.elementUnmatchedAttribute && this.delegate.elementUnmatchedAttribute(e, this.attributeName);
      }, e.prototype.elementAttributeChanged = function (e, t) {
        this.delegate.elementAttributeValueChanged && this.attributeName == t && this.delegate.elementAttributeValueChanged(e, t);
      }, e;
    }();

    function p(e, t, n) {
      d(e, t).add(n);
    }

    function h(e, t, n) {
      d(e, t).delete(n), function (e, t) {
        var n = e.get(t);
        null != n && 0 == n.size && e.delete(t);
      }(e, t);
    }

    function d(e, t) {
      var n = e.get(t);
      return n || (n = new Set(), e.set(t, n)), n;
    }

    var y,
        m = function () {
      function e() {
        this.valuesByKey = new Map();
      }

      return Object.defineProperty(e.prototype, "values", {
        get: function get() {
          return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
            return e.concat(Array.from(t));
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
            return e + t.size;
          }, 0);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.add = function (e, t) {
        p(this.valuesByKey, e, t);
      }, e.prototype.delete = function (e, t) {
        h(this.valuesByKey, e, t);
      }, e.prototype.has = function (e, t) {
        var n = this.valuesByKey.get(e);
        return null != n && n.has(t);
      }, e.prototype.hasKey = function (e) {
        return this.valuesByKey.has(e);
      }, e.prototype.hasValue = function (e) {
        return Array.from(this.valuesByKey.values()).some(function (t) {
          return t.has(e);
        });
      }, e.prototype.getValuesForKey = function (e) {
        var t = this.valuesByKey.get(e);
        return t ? Array.from(t) : [];
      }, e.prototype.getKeysForValue = function (e) {
        return Array.from(this.valuesByKey).filter(function (t) {
          t[0];
          return t[1].has(e);
        }).map(function (e) {
          var t = e[0];
          e[1];
          return t;
        });
      }, e;
    }(),
        b = (y = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      y(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        g = (function (e) {
      function t() {
        var t = e.call(this) || this;
        return t.keysByValue = new Map(), t;
      }

      b(t, e), Object.defineProperty(t.prototype, "values", {
        get: function get() {
          return Array.from(this.keysByValue.keys());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.add = function (t, n) {
        e.prototype.add.call(this, t, n), p(this.keysByValue, n, t);
      }, t.prototype.delete = function (t, n) {
        e.prototype.delete.call(this, t, n), h(this.keysByValue, n, t);
      }, t.prototype.hasValue = function (e) {
        return this.keysByValue.has(e);
      }, t.prototype.getKeysForValue = function (e) {
        var t = this.keysByValue.get(e);
        return t ? Array.from(t) : [];
      };
    }(m), function () {
      function e(e, t, n) {
        this.attributeObserver = new f(e, t, this), this.delegate = n, this.tokensByElement = new m();
      }

      return Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.attributeObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.attributeObserver.start();
      }, e.prototype.stop = function () {
        this.attributeObserver.stop();
      }, e.prototype.refresh = function () {
        this.attributeObserver.refresh();
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.attributeObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributeName", {
        get: function get() {
          return this.attributeObserver.attributeName;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.elementMatchedAttribute = function (e) {
        this.tokensMatched(this.readTokensForElement(e));
      }, e.prototype.elementAttributeValueChanged = function (e) {
        var t = this.refreshTokensForElement(e),
            n = t[0],
            r = t[1];
        this.tokensUnmatched(n), this.tokensMatched(r);
      }, e.prototype.elementUnmatchedAttribute = function (e) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(e));
      }, e.prototype.tokensMatched = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.tokenMatched(e);
        });
      }, e.prototype.tokensUnmatched = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.tokenUnmatched(e);
        });
      }, e.prototype.tokenMatched = function (e) {
        this.delegate.tokenMatched(e), this.tokensByElement.add(e.element, e);
      }, e.prototype.tokenUnmatched = function (e) {
        this.delegate.tokenUnmatched(e), this.tokensByElement.delete(e.element, e);
      }, e.prototype.refreshTokensForElement = function (e) {
        var t,
            n,
            r,
            o = this.tokensByElement.getValuesForKey(e),
            i = this.readTokensForElement(e),
            s = (t = o, n = i, r = Math.max(t.length, n.length), Array.from({
          length: r
        }, function (e, r) {
          return [t[r], n[r]];
        })).findIndex(function (e) {
          return !function (e, t) {
            return e && t && e.index == t.index && e.content == t.content;
          }(e[0], e[1]);
        });
        return -1 == s ? [[], []] : [o.slice(s), i.slice(s)];
      }, e.prototype.readTokensForElement = function (e) {
        var t = this.attributeName;
        return function (e, t, n) {
          return e.trim().split(/\s+/).filter(function (e) {
            return e.length;
          }).map(function (e, r) {
            return {
              element: t,
              attributeName: n,
              content: e,
              index: r
            };
          });
        }(e.getAttribute(t) || "", e, t);
      }, e;
    }());

    var v = function () {
      function e(e, t, n) {
        this.tokenListObserver = new g(e, t, this), this.delegate = n, this.parseResultsByToken = new WeakMap(), this.valuesByTokenByElement = new WeakMap();
      }

      return Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.tokenListObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.tokenListObserver.start();
      }, e.prototype.stop = function () {
        this.tokenListObserver.stop();
      }, e.prototype.refresh = function () {
        this.tokenListObserver.refresh();
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.tokenListObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributeName", {
        get: function get() {
          return this.tokenListObserver.attributeName;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.tokenMatched = function (e) {
        var t = e.element,
            n = this.fetchParseResultForToken(e).value;
        n && (this.fetchValuesByTokenForElement(t).set(e, n), this.delegate.elementMatchedValue(t, n));
      }, e.prototype.tokenUnmatched = function (e) {
        var t = e.element,
            n = this.fetchParseResultForToken(e).value;
        n && (this.fetchValuesByTokenForElement(t).delete(e), this.delegate.elementUnmatchedValue(t, n));
      }, e.prototype.fetchParseResultForToken = function (e) {
        var t = this.parseResultsByToken.get(e);
        return t || (t = this.parseToken(e), this.parseResultsByToken.set(e, t)), t;
      }, e.prototype.fetchValuesByTokenForElement = function (e) {
        var t = this.valuesByTokenByElement.get(e);
        return t || (t = new Map(), this.valuesByTokenByElement.set(e, t)), t;
      }, e.prototype.parseToken = function (e) {
        try {
          return {
            value: this.delegate.parseValueForToken(e)
          };
        } catch (e) {
          return {
            error: e
          };
        }
      }, e;
    }(),
        O = function () {
      function e(e, t) {
        this.context = e, this.delegate = t, this.bindingsByAction = new Map();
      }

      return e.prototype.start = function () {
        this.valueListObserver || (this.valueListObserver = new v(this.element, this.actionAttribute, this), this.valueListObserver.start());
      }, e.prototype.stop = function () {
        this.valueListObserver && (this.valueListObserver.stop(), delete this.valueListObserver, this.disconnectAllActions());
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.context.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.context.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "actionAttribute", {
        get: function get() {
          return this.schema.actionAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.context.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "bindings", {
        get: function get() {
          return Array.from(this.bindingsByAction.values());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connectAction = function (e) {
        var t = new u(this.context, e);
        this.bindingsByAction.set(e, t), this.delegate.bindingConnected(t);
      }, e.prototype.disconnectAction = function (e) {
        var t = this.bindingsByAction.get(e);
        t && (this.bindingsByAction.delete(e), this.delegate.bindingDisconnected(t));
      }, e.prototype.disconnectAllActions = function () {
        var e = this;
        this.bindings.forEach(function (t) {
          return e.delegate.bindingDisconnected(t);
        }), this.bindingsByAction.clear();
      }, e.prototype.parseValueForToken = function (e) {
        var t = s.forToken(e);
        if (t.identifier == this.identifier) return t;
      }, e.prototype.elementMatchedValue = function (e, t) {
        this.connectAction(t);
      }, e.prototype.elementUnmatchedValue = function (e, t) {
        this.disconnectAction(t);
      }, e;
    }(),
        E = function () {
      function e(e, t) {
        this.module = e, this.scope = t, this.controller = new e.controllerConstructor(this), this.bindingObserver = new O(this, this.dispatcher);

        try {
          this.controller.initialize();
        } catch (e) {
          this.handleError(e, "initializing controller");
        }
      }

      return e.prototype.connect = function () {
        this.bindingObserver.start();

        try {
          this.controller.connect();
        } catch (e) {
          this.handleError(e, "connecting controller");
        }
      }, e.prototype.disconnect = function () {
        try {
          this.controller.disconnect();
        } catch (e) {
          this.handleError(e, "disconnecting controller");
        }

        this.bindingObserver.stop();
      }, Object.defineProperty(e.prototype, "application", {
        get: function get() {
          return this.module.application;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.module.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.application.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dispatcher", {
        get: function get() {
          return this.application.dispatcher;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "parentElement", {
        get: function get() {
          return this.element.parentElement;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.handleError = function (e, t, n) {
        void 0 === n && (n = {});
        var r = this.identifier,
            o = this.controller,
            i = this.element;
        n = Object.assign({
          identifier: r,
          controller: o,
          element: i
        }, n), this.application.handleError(e, "Error " + t, n);
      }, e;
    }(),
        k = function () {
      var e = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      };

      return function (t, n) {
        function r() {
          this.constructor = t;
        }

        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    function w(e) {
      var t = A(e);
      return t.bless(), t;
    }

    var A = function () {
      function e(e) {
        function t() {
          var n = this && this instanceof t ? this.constructor : void 0;
          return Reflect.construct(e, arguments, n);
        }

        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t
          }
        }), Reflect.setPrototypeOf(t, e), t;
      }

      try {
        return (t = e(function () {
          this.a.call(this);
        })).prototype.a = function () {}, new t(), e;
      } catch (e) {
        return function (e) {
          return function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return k(t, e), t;
          }(e);
        };
      }

      var t;
    }(),
        P = function () {
      function e(e, t) {
        this.application = e, this.definition = function (e) {
          return {
            identifier: e.identifier,
            controllerConstructor: w(e.controllerConstructor)
          };
        }(t), this.contextsByScope = new WeakMap(), this.connectedContexts = new Set();
      }

      return Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.definition.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "controllerConstructor", {
        get: function get() {
          return this.definition.controllerConstructor;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contexts", {
        get: function get() {
          return Array.from(this.connectedContexts);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connectContextForScope = function (e) {
        var t = this.fetchContextForScope(e);
        this.connectedContexts.add(t), t.connect();
      }, e.prototype.disconnectContextForScope = function (e) {
        var t = this.contextsByScope.get(e);
        t && (this.connectedContexts.delete(t), t.disconnect());
      }, e.prototype.fetchContextForScope = function (e) {
        var t = this.contextsByScope.get(e);
        return t || (t = new E(this, e), this.contextsByScope.set(e, t)), t;
      }, e;
    }(),
        j = function () {
      function e(e) {
        this.scope = e;
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function (e) {
        return e = this.getFormattedKey(e), this.element.getAttribute(e);
      }, e.prototype.set = function (e, t) {
        return e = this.getFormattedKey(e), this.element.setAttribute(e, t), this.get(e);
      }, e.prototype.has = function (e) {
        return e = this.getFormattedKey(e), this.element.hasAttribute(e);
      }, e.prototype.delete = function (e) {
        return !!this.has(e) && (e = this.getFormattedKey(e), this.element.removeAttribute(e), !0);
      }, e.prototype.getFormattedKey = function (e) {
        return "data-" + this.identifier + "-" + e.replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        });
      }, e;
    }();

    function T(e, t) {
      return "[" + e + '~="' + t + '"]';
    }

    var B = function () {
      function e(e) {
        this.scope = e;
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.scope.schema;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.has = function (e) {
        return null != this.find(e);
      }, e.prototype.find = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = this.getSelectorForTargetNames(e);
        return this.scope.findElement(n);
      }, e.prototype.findAll = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = this.getSelectorForTargetNames(e);
        return this.scope.findAllElements(n);
      }, e.prototype.getSelectorForTargetNames = function (e) {
        var t = this;
        return e.map(function (e) {
          return t.getSelectorForTargetName(e);
        }).join(", ");
      }, e.prototype.getSelectorForTargetName = function (e) {
        var t = this.identifier + "." + e;
        return T(this.schema.targetAttribute, t);
      }, e;
    }(),
        x = function () {
      function e(e, t, n) {
        this.schema = e, this.identifier = t, this.element = n, this.targets = new B(this), this.data = new j(this);
      }

      return e.prototype.findElement = function (e) {
        return this.findAllElements(e)[0];
      }, e.prototype.findAllElements = function (e) {
        var t = this.element.matches(e) ? [this.element] : [],
            n = this.filterElements(Array.from(this.element.querySelectorAll(e)));
        return t.concat(n);
      }, e.prototype.filterElements = function (e) {
        var t = this;
        return e.filter(function (e) {
          return t.containsElement(e);
        });
      }, e.prototype.containsElement = function (e) {
        return e.closest(this.controllerSelector) === this.element;
      }, Object.defineProperty(e.prototype, "controllerSelector", {
        get: function get() {
          return T(this.schema.controllerAttribute, this.identifier);
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        _ = function () {
      function e(e, t, n) {
        this.element = e, this.schema = t, this.delegate = n, this.valueListObserver = new v(this.element, this.controllerAttribute, this), this.scopesByIdentifierByElement = new WeakMap(), this.scopeReferenceCounts = new WeakMap();
      }

      return e.prototype.start = function () {
        this.valueListObserver.start();
      }, e.prototype.stop = function () {
        this.valueListObserver.stop();
      }, Object.defineProperty(e.prototype, "controllerAttribute", {
        get: function get() {
          return this.schema.controllerAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.parseValueForToken = function (e) {
        var t = e.element,
            n = e.content,
            r = this.fetchScopesByIdentifierForElement(t),
            o = r.get(n);
        return o || (o = new x(this.schema, n, t), r.set(n, o)), o;
      }, e.prototype.elementMatchedValue = function (e, t) {
        var n = (this.scopeReferenceCounts.get(t) || 0) + 1;
        this.scopeReferenceCounts.set(t, n), 1 == n && this.delegate.scopeConnected(t);
      }, e.prototype.elementUnmatchedValue = function (e, t) {
        var n = this.scopeReferenceCounts.get(t);
        n && (this.scopeReferenceCounts.set(t, n - 1), 1 == n && this.delegate.scopeDisconnected(t));
      }, e.prototype.fetchScopesByIdentifierForElement = function (e) {
        var t = this.scopesByIdentifierByElement.get(e);
        return t || (t = new Map(), this.scopesByIdentifierByElement.set(e, t)), t;
      }, e;
    }(),
        S = function () {
      function e(e) {
        this.application = e, this.scopeObserver = new _(this.element, this.schema, this), this.scopesByIdentifier = new m(), this.modulesByIdentifier = new Map();
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.application.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.application.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "controllerAttribute", {
        get: function get() {
          return this.schema.controllerAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "modules", {
        get: function get() {
          return Array.from(this.modulesByIdentifier.values());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contexts", {
        get: function get() {
          return this.modules.reduce(function (e, t) {
            return e.concat(t.contexts);
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.scopeObserver.start();
      }, e.prototype.stop = function () {
        this.scopeObserver.stop();
      }, e.prototype.loadDefinition = function (e) {
        this.unloadIdentifier(e.identifier);
        var t = new P(this.application, e);
        this.connectModule(t);
      }, e.prototype.unloadIdentifier = function (e) {
        var t = this.modulesByIdentifier.get(e);
        t && this.disconnectModule(t);
      }, e.prototype.getContextForElementAndIdentifier = function (e, t) {
        var n = this.modulesByIdentifier.get(t);
        if (n) return n.contexts.find(function (t) {
          return t.element == e;
        });
      }, e.prototype.handleError = function (e, t, n) {
        this.application.handleError(e, t, n);
      }, e.prototype.scopeConnected = function (e) {
        this.scopesByIdentifier.add(e.identifier, e);
        var t = this.modulesByIdentifier.get(e.identifier);
        t && t.connectContextForScope(e);
      }, e.prototype.scopeDisconnected = function (e) {
        this.scopesByIdentifier.delete(e.identifier, e);
        var t = this.modulesByIdentifier.get(e.identifier);
        t && t.disconnectContextForScope(e);
      }, e.prototype.connectModule = function (e) {
        this.modulesByIdentifier.set(e.identifier, e), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
          return e.connectContextForScope(t);
        });
      }, e.prototype.disconnectModule = function (e) {
        this.modulesByIdentifier.delete(e.identifier), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
          return e.disconnectContextForScope(t);
        });
      }, e;
    }(),
        C = {
      controllerAttribute: "data-controller",
      actionAttribute: "data-action",
      targetAttribute: "data-target"
    },
        F = function F(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, a);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        N = function N(e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = r[2 & i[0] ? "return" : i[0] ? "throw" : "next"]) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [0, o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    },
        M = function () {
      function e(e, t) {
        void 0 === e && (e = document.documentElement), void 0 === t && (t = C), this.element = e, this.schema = t, this.dispatcher = new o(this), this.router = new S(this);
      }

      return e.start = function (t, n) {
        var r = new e(t, n);
        return r.start(), r;
      }, e.prototype.start = function () {
        return F(this, void 0, void 0, function () {
          return N(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, new Promise(function (e) {
                  "loading" == document.readyState ? document.addEventListener("DOMContentLoaded", e) : e();
                })];

              case 1:
                return e.sent(), this.router.start(), this.dispatcher.start(), [2];
            }
          });
        });
      }, e.prototype.stop = function () {
        this.router.stop(), this.dispatcher.stop();
      }, e.prototype.register = function (e, t) {
        this.load({
          identifier: e,
          controllerConstructor: t
        });
      }, e.prototype.load = function (e) {
        for (var t = this, n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        var o = Array.isArray(e) ? e : [e].concat(n);
        o.forEach(function (e) {
          return t.router.loadDefinition(e);
        });
      }, e.prototype.unload = function (e) {
        for (var t = this, n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        var o = Array.isArray(e) ? e : [e].concat(n);
        o.forEach(function (e) {
          return t.router.unloadIdentifier(e);
        });
      }, Object.defineProperty(e.prototype, "controllers", {
        get: function get() {
          return this.router.contexts.map(function (e) {
            return e.controller;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getControllerForElementAndIdentifier = function (e, t) {
        var n = this.router.getContextForElementAndIdentifier(e, t);
        return n ? n.controller : null;
      }, e.prototype.handleError = function (e, t, n) {
        console.error("%s\n\n%o\n\n%o", t, e, n);
      }, e;
    }();

    function L(e) {
      var t = e.prototype;
      (function (e) {
        var t = function (e) {
          var t = [];

          for (; e;) {
            t.push(e), e = Object.getPrototypeOf(e);
          }

          return t;
        }(e);

        return Array.from(t.reduce(function (e, t) {
          return function (e) {
            var t = e.targets;
            return Array.isArray(t) ? t : [];
          }(t).forEach(function (t) {
            return e.add(t);
          }), e;
        }, new Set()));
      })(e).forEach(function (e) {
        var n, r, o;
        return r = t, (n = {})[e + "Target"] = {
          get: function get() {
            var t = this.targets.find(e);
            if (t) return t;
            throw new Error('Missing target element "' + this.identifier + "." + e + '"');
          }
        }, n[e + "Targets"] = {
          get: function get() {
            return this.targets.findAll(e);
          }
        }, n["has" + function (e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }(e) + "Target"] = {
          get: function get() {
            return this.targets.has(e);
          }
        }, o = n, void Object.keys(o).forEach(function (e) {
          if (!(e in r)) {
            var t = o[e];
            Object.defineProperty(r, e, t);
          }
        });
      });
    }

    var I = function () {
      function e(e) {
        this.context = e;
      }

      return e.bless = function () {
        L(this);
      }, Object.defineProperty(e.prototype, "application", {
        get: function get() {
          return this.context.application;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "scope", {
        get: function get() {
          return this.context.scope;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "targets", {
        get: function get() {
          return this.scope.targets;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "data", {
        get: function get() {
          return this.scope.data;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.initialize = function () {}, e.prototype.connect = function () {}, e.prototype.disconnect = function () {}, e.targets = [], e;
    }();

    n.d(t, "a", function () {
      return M;
    }), n.d(t, "b", function () {
      return I;
    });
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    var r = {
      "./quantity_input_controller.js": 7,
      "./variant_selector_input_controller.js": 8
    };

    function o(e) {
      var t = i(e);
      return n(t);
    }

    function i(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    o.keys = function () {
      return Object.keys(r);
    }, o.resolve = i, e.exports = o, o.id = 6;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function i(e) {
      return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return a;
    });

    var a = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, i(t).apply(this, arguments));
      }

      var n, a, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (a = [{
        key: "initialize",
        value: function value() {
          this.setButtonStates();
        }
      }, {
        key: "changeQuantity",
        value: function value(e) {
          this.quantity < 1 && (this.quantity = 1);
        }
      }, {
        key: "increment",
        value: function value() {
          this.quantity++;
          var e = new Event("change", {
            bubbles: !0
          });
          this.inputTarget.dispatchEvent(e), this.setButtonStates();
        }
      }, {
        key: "decrement",
        value: function value() {
          if (this.quantity > this.min) {
            this.quantity--;

            var _e = new Event("change", {
              bubbles: !0
            });

            this.inputTarget.dispatchEvent(_e);
          }

          this.setButtonStates();
        }
      }, {
        key: "setButtonStates",
        value: function value() {
          this.quantity == this.min ? this.decrementButtonTarget.disabled = !0 : this.decrementButtonTarget.disabled = !1, this.quantity == this.max ? this.incrementButtonTarget.disabled = !0 : this.incrementButtonTarget.disabled = !1;
        }
      }, {
        key: "quantity",
        get: function get() {
          return parseInt(this.inputTarget.value);
        },
        set: function set(e) {
          this.inputTarget.value = e;
        }
      }, {
        key: "min",
        get: function get() {
          return parseInt(this.inputTarget.min);
        }
      }, {
        key: "max",
        get: function get() {
          return this.inputTarget.max ? parseInt(this.inputTarget.max) : 1 / 0;
        }
      }]) && r(n.prototype, a), c && r(n, c), t;
    }(n(0).b);

    var c, u, l;
    l = ["input", "decrementButton", "incrementButton"], (u = "targets") in (c = a) ? Object.defineProperty(c, u, {
      value: l,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[u] = l;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function i(e) {
      return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return a;
    });

    var a = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o(this, i(t).apply(this, arguments));
      }

      var n, a, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (a = [{
        key: "connect",
        value: function value() {
          this.variants.length > 1 && (this.selectVariant(), this.disableUnselectableOptions());
        }
      }, {
        key: "selectVariant",
        value: function value() {
          this.selectedVariant = this.variantForSelectedOptions[0];
        }
      }, {
        key: "disableUnselectableOptions",
        value: function value() {
          var _this = this;

          this.variantOptionSelectTargets.forEach(function (e) {
            var t = e.dataset.option;
            Array.from(e.options).forEach(function (e) {
              _this.variantsForOption({
                key: t,
                value: e.value
              }).every(function (e) {
                return e.disabled;
              }) && (e.disabled = !0);
            });
          });
        }
      }, {
        key: "variantsForOption",
        value: function value(e) {
          return Array.from(this.variants).filter(function (t) {
            return t.dataset[e.key] == e.value;
          });
        }
      }, {
        key: "variantIdsForOption",
        value: function value(e) {
          return this.variantsForOption(e).map(function (e) {
            return e.value;
          });
        }
      }, {
        key: "intersection",
        value: function value(e) {
          var t = [];
          var n = 0;

          for (; n < e.length;) {
            var _o = e[n];
            var _i = 0;

            for (; _i < _o.length;) {
              var r = _o[_i];
              -1 === t.indexOf(r) && 0 === e.filter(function (e) {
                return -1 === e.indexOf(r);
              }).length && t.push(r), _i++;
            }

            n++;
          }

          return t;
        }
      }, {
        key: "options",
        get: function get() {
          Array.from(this.variants).map(function (e) {
            return e.dataset;
          });
        }
      }, {
        key: "selectedVariant",
        get: function get() {
          return this.variantSelectTarget.options[this.variantSelectTarget.selectedIndex];
        },
        set: function set(e) {
          this.variantSelectTarget.value = e;
          var t = new Event("change");
          this.variantSelectTarget.dispatchEvent(t);
        }
      }, {
        key: "variantForSelectedOptions",
        get: function get() {
          var _this2 = this;

          var e = [];
          return this.selectedOptions.forEach(function (t) {
            return e.push(_this2.variantIdsForOption(t));
          }), this.intersection(e);
        }
      }, {
        key: "selectedOptions",
        get: function get() {
          var e = [];
          return this.variantOptionSelectTargets.forEach(function (t) {
            return e.push({
              key: t.dataset.option,
              value: t.options[t.selectedIndex].value
            });
          }), e;
        }
      }, {
        key: "variants",
        get: function get() {
          return this.variantSelectTarget.options;
        }
      }]) && r(n.prototype, a), c && r(n, c), t;
    }(n(0).b);

    var c, u, l;
    l = ["variantSelect", "variantOptionSelect"], (u = "targets") in (c = a) ? Object.defineProperty(c, u, {
      value: l,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[u] = l;
  },, function (e, t, n) {
    "use strict";

    n.r(t);
    n(1), n(2), n(3), n(4), n(5);
    var r = n(0);

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function i(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function a(e, t) {
      return (a = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var c = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i(this, s(t).apply(this, arguments));
      }

      var n, r, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && a(e, t);
      }(t, e), n = t, (r = [{
        key: "initialize",
        value: function value() {
          this.elementsConfig = {
            locale: "en"
          };
        }
      }, {
        key: "connect",
        value: function value() {
          this._initializeCardElement();
        }
      }, {
        key: "_initializeCardElement",
        value: function value() {
          var _this3 = this;

          this.stripe = Stripe(this.data.get("publishableKey")), this.elements = this.stripe.elements(this.elementsConfig), this.cardElement = this.elements.create("card", this.cardElementConfig), this.cardElement.mount(this.cardTarget), this.cardElement.addEventListener("change", function (e) {
            return _this3.onCardChange(e);
          });
        }
      }, {
        key: "onCardChange",
        value: function value(e) {
          var t = e.error ? e.error.message : "";
          this.numberTarget.classList.toggle("card_component__field--error", e.error), this.errors = t;
        }
      }, {
        key: "handlePayment",
        value: function value() {
          var _this4 = this;

          this.loading = !0, this.stripe.handleCardPayment(this.clientSecret, this.cardElement, this.cardPaymentData).then(function (e) {
            _this4.loading = !1, e.error ? _this4.onPaymentError(e) : _this4.onPaymentSuccess(e);
          });
        }
      }, {
        key: "onPaymentSuccess",
        value: function value(e) {}
      }, {
        key: "onPaymentError",
        value: function value(e) {
          this.numberTarget.classList.add("card__field--error"), this.errors = e.error.message;
        }
      }, {
        key: "errors",
        set: function set(e) {
          this.errorsTarget.innerText = e;
        }
      }, {
        key: "publishableKey",
        get: function get() {
          return this.data.get("publishableKey");
        }
      }, {
        key: "clientSecret",
        get: function get() {
          return this.data.get("clientSecret");
        }
      }, {
        key: "holder",
        get: function get() {
          return this.holderTarget.value;
        }
      }, {
        key: "email",
        get: function get() {
          return this.data.get("email");
        }
      }, {
        key: "cardPaymentData",
        get: function get() {
          return {
            payment_method_data: {
              billing_details: {
                address: this.billingAddress,
                email: this.email,
                name: this.holder
              }
            },
            shipping: {
              name: this.deliveryName,
              address: this.deliveryAddress
            }
          };
        }
      }, {
        key: "billingAddress",
        get: function get() {
          var e = JSON.parse(this.data.get("billingAddress"));
          return {
            line1: e.line1,
            line2: e.line2,
            postal_code: e.postal_code,
            city: e.city,
            state: e.state,
            country: e.country.data.alpha2
          };
        }
      }, {
        key: "deliveryAddress",
        get: function get() {
          var e = JSON.parse(this.data.get("deliveryAddress"));
          return {
            line1: e.line1,
            line2: e.line2,
            postal_code: e.postal_code,
            city: e.city,
            state: e.state,
            country: e.country.data.alpha2
          };
        }
      }, {
        key: "deliveryName",
        get: function get() {
          return JSON.parse(this.data.get("deliveryAddress")).full_name;
        }
      }, {
        key: "loading",
        set: function set(e) {
          this.element.classList.toggle(this.data.get("loadingClass"), e);
        }
      }]) && o(n.prototype, r), c && o(n, c), t;
    }(r.b);

    var u, l, f;
    f = ["errors", "card", "holder", "number", "billingAddress", "deliveryAddress"], (l = "targets") in (u = c) ? Object.defineProperty(u, l, {
      value: f,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : u[l] = f, n.d(t, "CardComponent", function () {
      return c;
    });
    var p = r.a.start(),
        h = n(6);
    p.load(function (e) {
      return e.keys().map(function (t) {
        return function (e, t) {
          var n = function (e) {
            var t = (e.match(/^(?:\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1];
            if (t) return t.replace(/_/g, "-").replace(/\//g, "--");
          }(t);

          if (n) return function (e, t) {
            var n = e.default;
            if ("function" == typeof n) return {
              identifier: t,
              controllerConstructor: n
            };
          }(e(t), n);
        }(e, t);
      }).filter(function (e) {
        return e;
      });
    }(h));
  }]);
});